/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_111Inputs */

const cs_ares_legal_form_111 = /** @type {(inputs: Ares_Legal_Form_111Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veřejná obchodní společnost`)
};

const en_ares_legal_form_111 = /** @type {(inputs: Ares_Legal_Form_111Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General partnership`)
};

/**
* | output |
* | --- |
* | "General partnership" |
*
* @param {Ares_Legal_Form_111Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_111 = /** @type {((inputs?: Ares_Legal_Form_111Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_111Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_111(inputs)
	return cs_ares_legal_form_111(inputs)
});